module.exports = __webpack_public_path__ + "static/media/standard-color.6eedda46.svg";